module.exports = fox._r("fonts/robotocondensed-regular-webfont.woff", __webpack_public_path__ + "_/_/_/root/fonts/3HyMK4N.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/robotocondensed-regular-webfont.woff
// module id = 184
// module chunks = 4